import styled from "styled-components";
import { SectionTitle } from "globalStyles/Containers";

export const CenteredCardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    text-align: center;
  }
`;

export const MissionCreatedTitle = styled(SectionTitle)`
  word-break: break-word;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  letter-spacing: 0.1px;
`;
